<script>
 import { customerMethods, customerListComputed, layoutMethods, erpUserRolesMethods, exportMethods } from "@/state/helpers";
 import { getModuleAccess } from '@/router/helper.js'
 import Swal from "sweetalert2";
 import { required } from "vuelidate/lib/validators";
 import flatPickr from "vue-flatpickr-component";
 import "flatpickr/dist/flatpickr.css";
  /**
   * Business Details component
   */
  export default {
    page: {
      title: "Business Details"
    },
    data() {
      return {
        title: "Business Details",
        items: [
          {
            text: "Peddlr",
          },
          {
            text: "Business Details",
            active: true,
          },
        ],
        cCurrentPage: 1,
        cPerPage: 0,
        pCurrentPage: 1,
        pPerPage: 0,
        sortBy: "value",
        sortDesc: false,
        customerFields: [
          {
            key: 'name',
            sortable: false
          },
          {
            key: 'mobile_number',
            sortable: false,
          }
        ],
        productFields: [
          {
            key: 'product',
            sortable: false
          },
          {
            key: 'price',
            sortable: false
          },
          {
            key: 'cost',
            sortable: false,
          },
          {
            key: 'stock',
            sortable: false
          },
          {
            key: 'sold',
            sortable: false
          },
        ],
        businessId: 0,
        businessInfoModule: {
          access: {
            update: true
          }
        },
        isWalletEnabled: true,
        showReasonModal: false,
        reason: '',
        submitted: false,
        showLogsModal: false,
        rangeOptions: {
          mode: "range",
        },
        logsFields: [
          {
            key: 'wallet_status',
            sortable: true
          },
          {
            key: 'reason',
            sortable: true
          },
          {
            key: 'date',
            sortable: true
          },
          {
            key: 'modified_by',
            sortable: true
          },
        ],
        reasonLogs: [],
        logsCurrentPage: 1,
        logsPerPage: 10,
        logsPageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        logsSort: 'c.id',
        logsSortBy: "value",
        logsSortDesc: false,
        logsDateRange: null,
        logsOrderDesc: true,
        freezeReasonOptions : [
          { value: '', text: 'Select Reason', disabled: true},
          { text: 'Suspicious Transactions', value: 'Suspicious Transactions' },
          { text: 'Fraudulent Activity', value: 'Fraudulent Activity' },
          { text: 'Hacked Account', value: 'Hacked Account' },
          { text: 'Identified under BSP Watchlist', value: 'Identified under BSP Watchlist' },
          { text: 'Bugs/Issue', value: 'Bugs/Issue' },
        ],
        enableReasonOptions : [
          { value: '', text: 'Select Reason', disabled: true},
          { text: 'Cleared by Management', value: 'Cleared by Management' },
          { text: 'Identified as Bugs/Issue', value: 'Identified as Bugs/Issue' },
          { text: 'No Hacking Identified', value: 'No Hacking Identified' },
          { text: 'Cleared from BSP Watchlist', value: 'Cleared from BSP Watchlist' },
        ],
        filter: {
          status: null
        },
        filterStatusOptions: [
          { text: 'All', value: null },
          { text: 'Enabled', value: 0 },
          { text: 'Freezed', value: 1 },
        ],
        isSearching: false
      };
    },
    components: {
      flatPickr
    },
    computed: {
      ...customerListComputed
    },
    validations: {
      reason: {required}
    },
    methods: {
      ...layoutMethods,
      ...customerMethods,
      ...erpUserRolesMethods,
      ...exportMethods,
      getCustomerList() {
        this.getBusinessCustomersList({ id: this.businessId, page: this.cCurrentPage  })
      },
      getProductList() {
        this.getBusinessProductsList({ id: this.businessId, page: this.pCurrentPage  })
      },
      onToggleFreeze() {
        if (this.businessInfoModule.access.update) { // if user is allowed to update
          let status = this.isWalletEnabled ? 'enable' : 'freeze';
          Swal.fire({ // this will ask a confirmation to user before performing the action.
              title: 'Are you sure?',
              text: `You want to ${status} the E-Product Wallet?`,
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                // display the Reason Modal
                this.showReasonModal = true;
              } else {
                this.isWalletEnabled = !this.isWalletEnabled;
                this.submitted = false;
              }
          })  
        } else {
          Swal.fire( // if user is not allowed to update
            "Access Restricted",
            "You are not allowed to update Business Info.",
            "warning"
          ).then(() => {
            this.isWalletEnabled = !this.isWalletEnabled;
          });
        }
      },
      submitAccountFreeze() {
        this.submitted = true;
        this.$v.$touch();
        
        if(this.reason != '') {
          this.showReasonModal = false;
          // set params
          let params = {
            businessId: this.businessId.toString(),
            status: this.isWalletEnabled ? '0' : '1',
            reason: this.reason,
            modified_by: JSON.parse(localStorage.getItem("userData")).email
          }
  
          // update the account_freeze status
          this.updateWalletStatus(params)
            .then(res => {
              if (res.status == 'ok') {
                let status = this.isWalletEnabled ? 'enabled' : 'freezed'
                Swal.fire({
                  title: "Update Successful!",
                  html: `${this.businessDetails.businessName} has been updated. <br/> The E-Product Wallet has been ${status}.`,
                  icon: "success"
                }).then(async () => {
                  this.getBusinessDetails({id: this.businessId});
                  this.getCustomerList();
                  this.getProductList();
                  // this.getReasonLogs();
                  this.reason = '';
                  this.submitted = false;
                });
              }
            })
            .catch((error) => {
              Swal.fire(
                "Update Failed!", 
                "An error occured while updating the wallet status.", 
                "error")
                .then(() => {
                  console.log(error);
                  this.getBusinessDetails({id: this.businessId});
                  this.getCustomerList();
                  this.getProductList();
                  // this.getReasonLogs();
                  this.reason = '';
                  this.submitted = false;
                });
            });
        }
      },
      onCancel() {
        this.showReasonModal = false;
        this.isWalletEnabled = !this.isWalletEnabled;
        this.submitted = false;
        this.reason = '';
      },
      tableSorting(action) {
        console.log('action: ', action)
        var column = "";
        switch(action.sortBy) {
            case 'wallet_status' :
                column = 'status';
                break;
            case 'reason' :
                column = 'reason';
                break;
            case 'date' :
                column = 'date';
                break;
            case 'modified_by' :
                column = 'name';
                break;
        }
        this.logsSort = column;
        this.logsOrderDesc = action.sortDesc;
        this.getReasonLogs();
      },
      async getReasonLogs() {
        this.logsCurrentPage = this.isSearching ? 1 : this.logsCurrentPage;

        let params = {
          businessId: this.businessId,
          dateRange: this.logsDateRange,
          page: this.logsCurrentPage,
          rows: this.logsPerPage,
          sort: this.logsSort,
          orderDesc: this.logsOrderDesc,
          status: this.filter.status
        };

        this.getReasonLogsList(params)
          .then(() => {
            this.reasonLogs = JSON.parse(JSON.stringify(this.reasonLogsList));
            this.isSearching = false;
          });
      },
      async showReasonLogsModal() {
        this.getReasonLogs()
          .then(() => {
            this.showLogsModal = true;
          })
      },
      closeLogsModal() {
        this.showLogsModal = false;
        this.logsDateRange = null;
        this.filter.status = null;
        this.logsCurrentPage = 1;
        this.logsPerPage = 10;
        this.logsSort = 'c.id';
        this.logsSortBy = 'value';
        this.logsSortDesc = false;
        this.logsOrderDesc = true;
      },
      async onExport() {
        let params = {
          module: 'freeze_account_logs',
          email: JSON.parse(localStorage.getItem('userData')).email,
          businessId: this.businessId,
          sort: this.logsSort,
          orderDesc: this.logsOrderDesc,
          filter: {
            dateRange: this.logsDateRange,
            status: this.filter.status
          }
        };

        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      }
    },
    async mounted() {
        this.businessId = this.$route.params.id

      this.getBusinessDetails({id: this.businessId})
        .then(() => {
          this.isWalletEnabled = this.businessDetails.account_freeze == 1 ? false : true;
        })
      this.getCustomerList()
      this.getProductList()
      // this.getReasonLogs();
      this.changeTitle({title: 'Business List'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Business List', to: { name: 'Business'} },
          { text: 'Business Detail', to: { name: 'Business Detail'} }
        ]
      });
      
      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Merchant Management', 'Business Info')
      .then((access) => this.businessInfoModule.access = access);
    }
  };
    
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xl-3">
        <div class="card">
            <div class="card-body text-center">
                <div class="avatar-xl mx-auto mb-2">
                <img
                    src="@/assets/images/users/food.jpg"
                    alt=""
                    class="rounded-circle img-thumbnail"
                />
                </div>
                <h5 class="mb-2">{{businessDetails.businessName}}</h5>
                <!-- <p class="text-muted small">Bussiness Name: <br/>MilkTea Gang</p> -->
            </div>

            <div class="d-flex border-top p-2 px-3">
                <div class="flex-grow-1 my-auto">
                    <div class="">
                        <i class="mdi mdi-wallet font-size-16 align-middle me-1"></i>
                        <span class="align-middle fw-semibold">Blvck Coins :</span>
                    </div>
                </div>
                <div class="flex-shrink-0 my-auto">
                    <span class="align-middle fw-bold">{{businessDetails.blvckCoins}}</span>
                    <b-link :disabled="!businessInfoModule.access.update" href="#foo" class="ms-1 "><i class="bx bx-plus-circle font-size-18 align-middle me-1"></i></b-link>
                </div>
            </div>

            <div class="d-flex border-top p-2 px-3">
                <div class="flex-grow-1 my-auto">
                    <i class="mdi mdi-wallet font-size-16 align-middle me-1"></i>
                    <span class="align-middle fw-semibold">PRP Points :</span>
                </div>
                <div class="flex-shrink-0 my-auto">
                    <span class="align-middle fw-bold">{{businessDetails.rewardPoints}}</span>
                    <b-link :disabled="!businessInfoModule.access.update" href="#foo" class="ms-1 "><i class="bx bx-plus-circle font-size-18 align-middle me-1"></i></b-link>
                </div>
            </div>
        </div>
        <!-- end card -->

        <div class="card">
          <div class="d-flex border-top p-2 px-3 border-bottom text-dark">
              <div class="flex-grow-1 my-auto pt-1 row">
                  <h5 class="mb-0 font-size-14 col-6 mt-1">Wallet Balance</h5>
                  <div class="col-6 text-end">
                    <input type="checkbox" id="switch1" switch="bool" checked="checked" v-model="isWalletEnabled" @change="onToggleFreeze()"/>
                    <label for="switch1" data-on-label="Enabled" data-off-label="Freezed" class="mb-0"></label>
                  </div>
              </div>
          </div>
          <ul class="list-unstyled mb-0">
              <li class="py-3 p-2 px-3 border-bottom">
                  <div class="d-flex align-items-center">
                      <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                          <i class='mdi mdi-wallet' :class="{ 'text-muted': businessDetails.account_freeze }"></i>
                      </div>
                      <div class="flex-grow-1" :class="{ 'text-muted': businessDetails.account_freeze }">
                          <p class="mb-1 font-size-13">E-load</p>
                          <!-- <h5 class="mb-0 font-size-14">{{businessDetails.businessType}}</h5> -->
                          <h5 class="mb-0 font-size-14 fw-normal" :class="{ 'text-muted': businessDetails.account_freeze }">
                            {{ businessDetails.eloadBalance | toCurrency }}
                          </h5>
                      </div>
                  </div>
              </li>
              <!-- end li -->
              <li class="py-3 p-2 px-3 border-bottom">
                  <div class="d-flex align-items-center">
                      <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                          <i class='mdi mdi-wallet' :class="{ 'text-muted': businessDetails.account_freeze }"></i>
                      </div>
                      <div class="flex-grow-1" :class="{ 'text-muted': businessDetails.account_freeze }">
                          <p class="mb-1 font-size-13">Bills Payment</p>
                          <h5 class="mb-0 font-size-14 fw-normal" :class="{ 'text-muted': businessDetails.account_freeze }">
                            {{ businessDetails.billsBalance | toCurrency }}
                          </h5>
                      </div>
                  </div>
              </li>
              <!-- end li -->
              <li class="py-3 p-2 px-3 border-bottom">
                  <div class="d-flex align-items-center">
                      <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                          <i class='bx bx-globe'></i>
                      </div>
                      <div class="flex-grow-1">
                          <p class="mb-1 font-size-13">Wallet Address</p>
                          <h5 class="mb-0 font-size-14">{{businessDetails.cogUserSub}}</h5>
                      </div>
                  </div>
              </li>
              <!-- end li -->
              <li class="py-3 p-2 px-3">
                  <div class="d-flex align-items-center">
                      <div class="flex-grow-1 row">
                          <p class="mb-1 font-size-13 col-6">Reason Log:</p>
                          <div class="mb-1 col-6 text-end">
                              <b-link class="small fw-semibold" @click="showReasonLogsModal()">View</b-link>
                          </div>
                      </div>
                  </div>
              </li>
              <!-- end li -->
          </ul>
        </div>
        <!-- end card -->
        
        <!-- end card -->
        <div class="card">
            <div class="card-body">
                <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                    <div class="flex-grow-1 my-auto">
                        <span class="align-middle">Business Information</span>
                    </div>
                    <!-- <div class="flex-shrink-0 my-auto">
                        <b-link href="#foo" class="small fw-semibold">View</b-link>
                    </div> -->
                </div>
                <ul class="list-unstyled mb-0">
                    <li class="pb-3">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-buildings' ></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13">Business Type</p>
                                <h5 class="mb-0 font-size-14">{{businessDetails.businessType}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                    <li class="py-3">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-user-circle'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13">Business Owner</p>
                                <h5 class="mb-0 font-size-14">
                                  <router-link v-bind:to="'/subscriber-details/' +businessDetails.subscriberId">{{businessDetails.subscriberName }}</router-link>
                                </h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                    <li class="py-3">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-phone'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13">Business Number</p>
                                <h5 class="mb-0 font-size-14">{{businessDetails.businessMobileNumber}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                    <li class="py-3">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-time-five'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13">Business Hours</p>
                                <h5 class="mb-0 font-size-14">{{businessDetails.businessHours}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                    <li class="py-3">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-map'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13">Business Location</p>
                                <h5 class="mb-0 font-size-14">{{businessDetails.businessLocation}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                    <li class="py-3">
                        <div class="d-flex align-items-center">
                            <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                                <i class='bx bx-map-pin'></i>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-1 font-size-13">Business Address</p>
                                <h5 class="mb-0 font-size-14">{{businessDetails.businessLocation}}</h5>
                            </div>
                        </div>
                    </li>
                    <!-- end li -->
                </ul>
            </div>
          <!-- end card body -->
        </div>
        <!-- end card -->

        <div class="card">
          <div class="card-body">
            <div>
              <ul class="list-unstyled mb-0 text-muted">
                <li>
                  <div class="d-flex align-items-center py-2">
                    <div class="flex-grow-1">
                      <i class="mdi mdi-facebook font-size-16 text-blue me-1"></i>
                      Facebook
                    </div>
                    <div class="flex-shrink-0">
                      <div>{{socialMedias.Facebook}}</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center py-2">
                    <div class="flex-grow-1">
                      <i
                        class="mdi mdi-twitter font-size-16 text-info me-1"
                      ></i>
                      Twitter
                    </div>
                    <div class="flex-shrink-0">
                      <div>{{socialMedias.Twitter}}</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center py-2">
                    <div class="flex-grow-1">
                      <i
                        class="mdi mdi-instagram font-size-16 text-danger me-1"
                      ></i>
                      Instagram
                    </div>
                    <div class="flex-shrink-0">
                      <div>{{socialMedias.Instagram}}</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center py-2">
                    <div class="flex-grow-1">
                      <i
                        class="mdi mdi-youtube font-size-16 text-danger me-1"
                      ></i>
                      Youtube
                    </div>
                    <div class="flex-shrink-0">
                      <div>{{socialMedias.Youtube}}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->

      <div class="col-xl-9">
        <div class="row">
            <div class="col-lg-12" v-if="false">
                <div class="row">
                    <div class="col-xl-4 col-sm-6">
                        <div class="card border shadow-none">
                            <div class="card-body">
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar-sm">
                                            <div class="avatar-title bg-light text-secondary rounded-circle font-size-18">
                                                <i class='bx bx-gas-pump'></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex-grow-1 overflow-hidden">
                                        <p class="mb-1 text-truncate text-muted">
                                            Total Product Upload
                                        </p>
                                        <h5 class="font-size-16 mb-0">5,000.00</h5>
                                    </div>
                                </div>
                            </div>
                            <!-- end card body -->
                            <b-button class="rounded-0 rounded-bottom" size="sm" variant="primary">EXPORT</b-button>
                        </div>
                        <!-- end card -->
                    </div>
                    <!-- end col -->
                    <div class="col-xl-4 col-sm-6">
                        <div class="card border shadow-none">
                            <div class="card-body">
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar-sm">
                                            <div class="avatar-title bg-light text-secondary rounded-circle font-size-18">
                                            <i class='bx bx-gas-pump'></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex-grow-1 overflow-hidden">
                                        <p class="mb-1 text-truncate text-muted">
                                            Total Transaction
                                        </p>
                                        <h5 class="font-size-16 mb-0">5,000.00</h5>
                                        </div>
                                </div>
                            </div>
                            <!-- end card body -->
                            <b-button class="rounded-0 rounded-bottom" size="sm" variant="primary">EXPORT</b-button>
                        </div>
                        <!-- end card -->
                    </div>
                    <!-- end col -->
                    <div class="col-xl-4 col-sm-6">
                        <div class="card border shadow-none">
                            <div class="card-body">
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar-sm">
                                            <div class="avatar-title bg-light text-secondary rounded-circle font-size-18">
                                            <i class='bx bx-gas-pump'></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex-grow-1 overflow-hidden">
                                        <p class="mb-1 text-truncate text-muted">
                                            Total Profit
                                        </p>
                                        <h5 class="font-size-16 mb-0">5,000.00</h5>
                                        </div>
                                </div>
                            </div>
                            <!-- end card body -->
                            <b-button class="rounded-0 rounded-bottom" size="sm" variant="primary">EXPORT</b-button>
                        </div>
                        <!-- end card -->
                    </div>
                    <!-- end col -->
                </div>
                <!-- end card -->
            </div>

          <b-tabs
            class="mt-n5 pt-5"
            content-class="card card-body mt-3"
            nav-class="nav-tabs-custom"
            nav-wrapper-class="nav-tabs-custom" v-if="false"
          >
          
            <b-tab title="Customer List" active>
              <!-- table responsive -->
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table striped :items="customerList" :fields="customerFields"                
                  :per-page="cPerPage"
                  :current-page="cCurrentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                   responsive="sm">
                     <template #cell(name)="data">
                       <span>{{data.item.customerName}}</span>
                     </template>
                     <template #cell(mobile_number)="data">
                       <span>{{data.item.customerMobileNumber}}</span>
                     </template>                   
                  </b-table>
                   
                </div>
              </div>
              <!-- end table responsive -->
              <div class="row g-0 text-center" v-if="customerTotal == 0">
                <span>No data to display.</span>
              </div>
              <!-- pagination -->
              <div class="row g-0 text-center text-sm-start" v-if="customerTotal != 0 && customerTotal > 10">
                <div class="col-sm-6">
                    <div class="">
                    <p class="mb-sm-0" v-if="customerTotal >= 10">Showing {{cCurrentPage * 10 + 1}} to {{(cCurrentPage * 10) + 10}} of {{customerTotal}} entries</p>
                    <p class="mb-sm-0" v-if="customerTotal < 10">Showing {{customerTotal}} of {{customerTotal}} entries</p>
                  </div>
                </div>
                <!-- end col -->
                <div class="col-sm-6 text-lg-end text-sm-center">
                  <div class="row">
                    <div class="d-flex justify-content-center justify-content-lg-end">
                      <div
                        class="dataTables_paginate paging_simple_numbers"
                      >
                        <!-- pagination -->
                        <b-pagination
                          class="pagination-rounded"
                          v-model="cCurrentPage"
                          :total-rows="customerTotal"
                          :per-page="cPerPage"
                          @change="cCurrentPage = $event;getCustomerList()"

                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
              <!-- end pagination -->

            </b-tab>

            <b-tab title="Product List">
              <!-- table responsive -->
              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                   <b-table striped :items="productList" :fields="productFields" responsive="sm">
                     <template #cell(product)="data">
                       <span>{{data.item.productName}}</span>
                     </template>
                      <template #cell(price)="data">
                       <span>{{data.item.productPrice}}</span>
                     </template>
                     <template #cell(cost)="data">
                       <span>{{data.item.productCost}}</span>
                     </template>
                     <template #cell(stock)="data">
                       <span>{{data.item.availableStocks}}</span>
                     </template>
                     <template #cell(sold)="data">
                       <span>{{data.item.productSold}}</span>
                     </template>
                   </b-table>
                </div>
              </div>
              <!-- end table responsive -->

              <!-- pagination -->
              <div class="row g-0 text-center text-sm-start">
                <div class="col-sm-6">
                  <div class="">
                    <p class="mb-sm-0" v-if="productTotal >= 10">Showing {{pCurrentPage * 10 + 1}} to {{(pCurrentPage * 10) + 10}} of {{productTotal}} entries</p>
                    <p class="mb-sm-0" v-if="productTotal < 10">Showing {{productTotal}} of {{productTotal}} entries</p>
                  </div>
                </div>
                <!-- end col -->
                <div class="col-sm-6 text-lg-end text-sm-center">
                  <div class="row">
                    <div class="d-flex justify-content-center justify-content-lg-end">
                      <div
                        class="dataTables_paginate paging_simple_numbers"
                      >
                        <!-- pagination -->
                        <b-pagination
                          class="pagination-rounded"
                          v-model="pCurrentPage"
                          :total-rows="productTotal"
                          :per-page="pPerPage"
                          @change="pCurrentPage = $event;getProductList()"

                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
              <!-- end pagination -->
            </b-tab>
          </b-tabs>

          <div class="card" v-if="true">
            <div class="card-body p-0 pt-2">
              <b-tabs
                content-class="p-3 text-muted"
                nav-class="nav-tabs-custom"
              >
                <b-tab active class="border-0">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Customer List</span>
                  </template>
                  <!-- table responsive -->
                  <div class="table-responsive">
                    <div class="table align-middle table-nowrap">
                      <b-table striped :items="customerList" :fields="customerFields"                
                      :per-page="cPerPage"
                      :current-page="cCurrentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      responsive="sm">
                        <template #cell(name)="data">
                          <span>{{data.item.customerName}}</span>
                        </template>
                        <template #cell(mobile_number)="data">
                          <span>{{data.item.customerMobileNumber}}</span>
                        </template>                   
                      </b-table>
                      
                    </div>
                  </div>
                  <!-- end table responsive -->
                  <div class="row g-0 text-center" v-if="customerTotal == 0">
                    <span>No data to display.</span>
                  </div>
                  <!-- pagination -->
                  <div class="row g-0 text-center text-sm-start" v-if="customerTotal != 0 && customerTotal > 10">
                    <div class="col-sm-6">
                        <div class="">
                        <p class="mb-sm-0" v-if="customerTotal >= 10">Showing {{cCurrentPage * 10 + 1}} to {{(cCurrentPage * 10) + 10}} of {{customerTotal}} entries</p>
                        <p class="mb-sm-0" v-if="customerTotal < 10">Showing {{customerTotal}} of {{customerTotal}} entries</p>
                      </div>
                    </div>
                    <!-- end col -->
                    <div class="col-sm-6 text-lg-end text-sm-center">
                      <div class="row">
                        <div class="d-flex justify-content-center justify-content-lg-end">
                          <div
                            class="dataTables_paginate paging_simple_numbers"
                          >
                            <!-- pagination -->
                            <b-pagination
                              class="pagination-rounded"
                              v-model="cCurrentPage"
                              :total-rows="customerTotal"
                              :per-page="cPerPage"
                              @change="cCurrentPage = $event;getCustomerList()"

                            ></b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end col -->
                  </div>
                  <!-- end pagination -->
                </b-tab><!-- end of customer list-->
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="far fa-user"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Product List</span>
                  </template>
                  <!-- table responsive -->
                  <div class="table-responsive">
                    <div class="table align-middle table-nowrap">
                      <b-table striped :items="productList" :fields="productFields" responsive="sm">
                        <template #cell(product)="data">
                          <span>{{data.item.productName}}</span>
                        </template>
                          <template #cell(price)="data">
                          <span>{{data.item.productPrice}}</span>
                        </template>
                        <template #cell(cost)="data">
                          <span>{{data.item.productCost}}</span>
                        </template>
                        <template #cell(stock)="data">
                          <span>{{data.item.availableStocks}}</span>
                        </template>
                        <template #cell(sold)="data">
                          <span>{{data.item.productSold}}</span>
                        </template>
                      </b-table>
                    </div>
                  </div>
                  <!-- end table responsive -->

                  <!-- pagination -->
                  <div class="row g-0 text-center text-sm-start">
                    <div class="col-sm-6">
                      <div class="">
                        <p class="mb-sm-0" v-if="productTotal >= 10">Showing {{pCurrentPage * 10 + 1}} to {{(pCurrentPage * 10) + 10}} of {{productTotal}} entries</p>
                        <p class="mb-sm-0" v-if="productTotal < 10">Showing {{productTotal}} of {{productTotal}} entries</p>
                      </div>
                    </div>
                    <!-- end col -->
                    <div class="col-sm-6 text-lg-end text-sm-center">
                      <div class="row">
                        <div class="d-flex justify-content-center justify-content-lg-end">
                          <div
                            class="dataTables_paginate paging_simple_numbers"
                          >
                            <!-- pagination -->
                            <b-pagination
                              class="pagination-rounded"
                              v-model="pCurrentPage"
                              :total-rows="productTotal"
                              :per-page="pPerPage"
                              @change="pCurrentPage = $event;getProductList()"

                            ></b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end col -->
                  </div>
                  <!-- end pagination -->
                </b-tab><!--Product List-->
              </b-tabs>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <b-modal
      v-model="showReasonModal"
      size="md"
      centered
      hide-header
      hide-footer
      hide-header-close
    >
      <form class="px-4 py-3" @submit.prevent="submitAccountFreeze()">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="mb-1">
              <i class="mdi mdi-wallet wallet-icon-custom"></i>
            </div>
            <p class="form-label large fw-bold mt-2" style="font-size: 1.5em;">E-Product Wallet</p>
            <p class="form-label mt-2 mb-3 px-5">Before you {{ isWalletEnabled ? 'enable' : 'freeze' }} the e-Product wallet, please let us know the reason.</p>
          </div>

          <div class="col-md-12 mb-3 px-3">
            <b-form-select
              class="form-select" 
              v-model="reason"
              :options="isWalletEnabled ? enableReasonOptions : freezeReasonOptions"
              track-by="value"
              label="text"
              :class="{'is-invalid': submitted && $v.reason.$error}"
              />
            <!-- <b-form-textarea
              class="mt-3 form-control"
              :class="{'is-invalid': submitted && $v.reason.$error}"
              id="textarea"
              v-model="reason"
              placeholder="Type here the reason..."  
              rows="3"
              max-rows="6"
              trim
              :state="reason.length > 150 ? false : null"
            ></b-form-textarea> -->
            <div
              v-if="submitted && !$v.reason.required"
              class="invalid-feedback" >
              Reason is required.
            </div>
            <!-- <div
              v-if="reason.length > 150"
              class="invalid-feedback" >
              Exceeds 150 characters.
            </div> -->
            <!-- <div class="mt-1">
              <p class="small text-muted">{{reason.length}}/150 characters</p>
            </div> -->
          </div>
        </div>
        <div class="text-end mt-3 px-1">
          <b-button
            variant="light"
            class="w-sm"
            @click="onCancel"
            >Cancel</b-button
          >
          <b-button 
            variant="primary" 
            class="w-sm ms-2"
            type="submit"
            :disabled="reason.length > 150"
            >Save</b-button
          >
        </div>
      </form>
    </b-modal>

    <b-modal
      v-model="showLogsModal"
      size="xl"
      centered
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
    >
      <form class="px-4 py-3">
        <div class="row">
          <div class="col-lg-12">
            <!-- <div class="card">
            </div> -->
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <h5 class="card-title">
                      Reason Log  
                    </h5>
                  </div>
                </div>

                <!-- Date Range -->
                <div class="col-md-12">
                  <div class="d-flex flex-wrap mt-3 mb-2 px-3 ta-right gap-2">
                    <div class="col-sm-3" style="width: fit-content">
                      <b-form-group description="Filter by date">
                        <flat-pickr
                          v-model="logsDateRange"
                          :config="rangeOptions"
                          placeholder="Select a date range"
                          class="form-control"
                          style="width: 250px"
                        ></flat-pickr>
                      </b-form-group>
                    </div>
                    <div class="col-sm-2">
                      <b-form-group label-for="status" description="Filter by status">
                        <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none"
                          v-model="filter.status"
                          :options="filterStatusOptions"
                        ></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col-sm-1" style="width: fit-content">
                      <b-button variant="primary" type="button" @click="isSearching =true; getReasonLogs()" class="px-2 d-flex align-items-center">
                        <div><i class='bx bx-search bx-fw'></i></div>
                        <div>Search</div>
                      </b-button>
                    </div>
                    <div class="col-sm-1" style="width: fit-content">
                      <b-button variant="primary" @click="onExport" type="button" class="px-2 d-flex align-items-center">
                        <div><i class='uil uil-export me-1'></i></div>
                        <div>Export</div>
                      </b-button>
                    </div>
                  </div>

                </div>
              </div>

              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="reasonLogsList"
                    :fields="logsFields"
                    responsive="sm"
                    :current-page="logsCurrentPage"
                    :sort-by.sync="logsSortBy"
                    :sort-desc.sync="logsSortDesc"
                    class="table-check"
                    @sort-changed="tableSorting"
                  >
                    <template #cell(wallet_status)="data">
                      <p class="text-body m-0">
                        {{ data.item.freezeStatus == 1 ? 'Freezed' : 'Enabled' }}
                      </p>
                    </template>

                    <template #cell(reason)="data">
                      <div 
                        class="text-body m-0" 
                        v-b-tooltip.hover.bottom 
                        :title="data.item.reason"
                        v-if="data.item.reason.length > 50">
                          <span>
                            {{ `${data.item.reason.substring(0,50)}...` }} 
                          </span> 
                      </div>
                      <p class="text-body m-0" v-else>{{ data.item.reason }} </p>
                    </template>

                    <template #cell(date)="data">
                      <p class="text-body m-0">{{ data.item.modifiedAt | formatDate }}</p>
                    </template>

                    <template #cell(modified_by)="data">
                      <p class="text-body m-0">{{ data.item.modifiedByName }}</p>
                    </template>
                  </b-table>
                </div>
              </div>
              <!-- end table responsive -->

              <div class="row g-0 text-center" v-if="reasonLogsTotal == 0">
                <span>No data to display.</span>
              </div>
              <div class="row g-0 text-center text-sm-start" v-if="reasonLogsTotal != 0 && reasonLogsTotal > 10">
                <!-- end col -->
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col">
                      <div class="form-group row pull-left">
                        <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                        <div class="col-sm-6">
                          <b-form-group label-for="display-record">
                            <b-form-select class="form-select shadow-none w-fit"
                              id="display-record"
                              v-model="logsPerPage"
                              :options="logsPageOptions"
                              @change="getReasonLogs()"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                      </div>
                      <div
                        class="dataTables_paginate paging_simple_numbers float-end" 
                        v-if="reasonLogsTotal > logsPerPage"
                      >
                        <!-- pagination -->
                        <b-pagination
                          class="pagination-rounded"
                          v-model="logsCurrentPage"
                          :total-rows="reasonLogsTotal"
                          :per-page="logsPerPage"
                          @input="getReasonLogs()"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3 px-1">
          <b-button
            variant="light"
            class="w-sm"
            @click="closeLogsModal()"
            >Close</b-button
          >
        </div>
      </form>
    </b-modal>
  </div>
</template>

<style>
.wallet-icon-custom {
  font-size: 7em;
  color: #0e0e0e;
}

input[switch] + label {
  width: 78px;
}

input[switch]:checked + label:after {
    left: 55px;
}
</style>
